import * as yup from 'yup';

export const searchOwnerSchema = yup.object({
    dni: yup.string().label('dni').min(5, 'No de identificación no valido').required('Este campo es requerido').matches(/^[0-9]+$/, 'No de identificación no valido'),
});

export type searchOwnerSchemaType = yup.InferType<typeof searchOwnerSchema>
